import { Preferences } from '@capacitor/preferences'

/**
 * Storage Service Wrapper for Capacitor Preferences
 * Provides simple get/set/remove methods with JSON serialization
 * Used for push notification device token storage
 */
const storageService = {
  /**
   * Get a value from storage
   * @param {string} key - Storage key
   * @returns {Promise<any|null>} Parsed value or null if not found
   */
  async get(key) {
    try {
      const { value } = await Preferences.get({ key })
      return value ? JSON.parse(value) : null
    } catch (error) {
      console.error(`Storage get error for key "${key}":`, error)
      return null
    }
  },
  
  /**
   * Set a value in storage
   * @param {string} key - Storage key
   * @param {any} value - Value to store (will be JSON serialized)
   * @returns {Promise<void>}
   */
  async set(key, value) {
    try {
      await Preferences.set({
        key,
        value: JSON.stringify(value)
      })
    } catch (error) {
      console.error(`Storage set error for key "${key}":`, error)
      throw error
    }
  },
  
  /**
   * Remove a value from storage
   * @param {string} key - Storage key
   * @returns {Promise<void>}
   */
  async remove(key) {
    try {
      await Preferences.remove({ key })
    } catch (error) {
      console.error(`Storage remove error for key "${key}":`, error)
      throw error
    }
  }
}

export default storageService
